// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-detail
{
}

	.project-detail .project-warning-container{
		background: #EB7038;
		color: white;
		display: flex;
		flex-direction: row;
		font-size: 17px;
		padding: 1em;
		gap: 1em;
		align-items: center;
	}

	.project-detail .project-header
	{
		position: relative;
		height: 92px;
		padding-left: 92px;
		padding-right: 16px;
		border-bottom: solid 1px #c7c7cb;
	}

		.project-detail .project-header .project-brand
		{
			position: absolute;
			left: 16px;
			top: 16px;
			width: 60px;
			height: 60px;
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center center;
			display: inline-block;
		}

		.project-detail .project-header .project-info
		{
			display: table-cell;
			height: 92px;
			vertical-align: middle;
		}

			.project-detail .project-header .project-info .project-name
			{
				font-size: 17px;
				font-weight: bold;
			}

			.project-detail .project-header .project-info .project-organization
			{
				font-size: 12px;
				color: #9A9A9A;
			}

	.project-detail .project-detail-section
	{
		margin-left: 16px;
		padding-right: 16px;
		padding-top: 16px;
		border-bottom: solid 1px #c7c7cb;
		padding-bottom: 16px;
	}

		.project-detail .project-detail-section:last-child
		{
			border-bottom: none;
		}

	.project-detail .project-section-header
	{
		margin-bottom: 16px;
		font-size: 18px;
		font-weight: bold;
	}

	.project-detail .project-about
	{
		font-size: 14px;
		color: #686868;
	}


	.project-detail .tracking-features
	{
		margin-top: 16px;
	}

	.project-detail .tracking-feature
	{
		color: #686868;
		margin-top: 5px;
	}

		.project-detail .tracking-feature .fa-heartbeat
		{
			color: #CC4733;
		}

		.project-detail .tracking-feature .fa-location-arrow
		{
			color: #4483C8;
		}

		.project-detail .tracking-feature .fa-medkit
		{
			color: #4483C8;
		}

	.project-detail .join-button
	{
		margin-top: 16px;
		border: 2px solid #366DBC;
	}

	.project-detail .decline-button
	{
		height: 26px;
		margin-top: 16px;
		text-align: center;
		color: #ED1C24;
		font-size: 12px;
		cursor: pointer;
	}

	.project-detail .consent-document-link
	{
		display: block;
		text-decoration: none;
		color: #5381c2;
		font-size: 15px;
		margin-bottom: 16px;
	}

		.project-detail .consent-document-link:last-child
		{
			margin-bottom: 0;
		}

	.project-detail .project-about a
	{
		font-size: 16px;
		display: block;
		color: #5381c2;
		text-decoration: none;
	}

	.project-detail .contact-info a
	{
		margin-bottom: 5px;
	}
`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/ProjectDetail.css"],"names":[],"mappings":"AAAA;;AAEA;;CAEC;EACC,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,mBAAmB;CACpB;;CAEA;;EAEC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;CACjC;;EAEC;;GAEC,kBAAkB;GAClB,UAAU;GACV,SAAS;GACT,WAAW;GACX,YAAY;GACZ,wBAAwB;GACxB,4BAA4B;GAC5B,kCAAkC;GAClC,qBAAqB;EACtB;;EAEA;;GAEC,mBAAmB;GACnB,YAAY;GACZ,sBAAsB;EACvB;;GAEC;;IAEC,eAAe;IACf,iBAAiB;GAClB;;GAEA;;IAEC,eAAe;IACf,cAAc;GACf;;CAEF;;EAEC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;CACrB;;EAEC;;GAEC,mBAAmB;EACpB;;CAED;;EAEC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;CAClB;;CAEA;;EAEC,eAAe;EACf,cAAc;CACf;;;CAGA;;EAEC,gBAAgB;CACjB;;CAEA;;EAEC,cAAc;EACd,eAAe;CAChB;;EAEC;;GAEC,cAAc;EACf;;EAEA;;GAEC,cAAc;EACf;;EAEA;;GAEC,cAAc;EACf;;CAED;;EAEC,gBAAgB;EAChB,yBAAyB;CAC1B;;CAEA;;EAEC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;CAChB;;CAEA;;EAEC,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;CACpB;;EAEC;;GAEC,gBAAgB;EACjB;;CAED;;EAEC,eAAe;EACf,cAAc;EACd,cAAc;EACd,qBAAqB;CACtB;;CAEA;;EAEC,kBAAkB;CACnB","sourcesContent":[".project-detail\n{\n}\n\n\t.project-detail .project-warning-container{\n\t\tbackground: #EB7038;\n\t\tcolor: white;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tfont-size: 17px;\n\t\tpadding: 1em;\n\t\tgap: 1em;\n\t\talign-items: center;\n\t}\n\n\t.project-detail .project-header\n\t{\n\t\tposition: relative;\n\t\theight: 92px;\n\t\tpadding-left: 92px;\n\t\tpadding-right: 16px;\n\t\tborder-bottom: solid 1px #c7c7cb;\n\t}\n\n\t\t.project-detail .project-header .project-brand\n\t\t{\n\t\t\tposition: absolute;\n\t\t\tleft: 16px;\n\t\t\ttop: 16px;\n\t\t\twidth: 60px;\n\t\t\theight: 60px;\n\t\t\tbackground-size: contain;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center center;\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t.project-detail .project-header .project-info\n\t\t{\n\t\t\tdisplay: table-cell;\n\t\t\theight: 92px;\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t\t.project-detail .project-header .project-info .project-name\n\t\t\t{\n\t\t\t\tfont-size: 17px;\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\n\t\t\t.project-detail .project-header .project-info .project-organization\n\t\t\t{\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: #9A9A9A;\n\t\t\t}\n\n\t.project-detail .project-detail-section\n\t{\n\t\tmargin-left: 16px;\n\t\tpadding-right: 16px;\n\t\tpadding-top: 16px;\n\t\tborder-bottom: solid 1px #c7c7cb;\n\t\tpadding-bottom: 16px;\n\t}\n\n\t\t.project-detail .project-detail-section:last-child\n\t\t{\n\t\t\tborder-bottom: none;\n\t\t}\n\n\t.project-detail .project-section-header\n\t{\n\t\tmargin-bottom: 16px;\n\t\tfont-size: 18px;\n\t\tfont-weight: bold;\n\t}\n\n\t.project-detail .project-about\n\t{\n\t\tfont-size: 14px;\n\t\tcolor: #686868;\n\t}\n\n\n\t.project-detail .tracking-features\n\t{\n\t\tmargin-top: 16px;\n\t}\n\n\t.project-detail .tracking-feature\n\t{\n\t\tcolor: #686868;\n\t\tmargin-top: 5px;\n\t}\n\n\t\t.project-detail .tracking-feature .fa-heartbeat\n\t\t{\n\t\t\tcolor: #CC4733;\n\t\t}\n\n\t\t.project-detail .tracking-feature .fa-location-arrow\n\t\t{\n\t\t\tcolor: #4483C8;\n\t\t}\n\n\t\t.project-detail .tracking-feature .fa-medkit\n\t\t{\n\t\t\tcolor: #4483C8;\n\t\t}\n\n\t.project-detail .join-button\n\t{\n\t\tmargin-top: 16px;\n\t\tborder: 2px solid #366DBC;\n\t}\n\n\t.project-detail .decline-button\n\t{\n\t\theight: 26px;\n\t\tmargin-top: 16px;\n\t\ttext-align: center;\n\t\tcolor: #ED1C24;\n\t\tfont-size: 12px;\n\t\tcursor: pointer;\n\t}\n\n\t.project-detail .consent-document-link\n\t{\n\t\tdisplay: block;\n\t\ttext-decoration: none;\n\t\tcolor: #5381c2;\n\t\tfont-size: 15px;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t\t.project-detail .consent-document-link:last-child\n\t\t{\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t.project-detail .project-about a\n\t{\n\t\tfont-size: 16px;\n\t\tdisplay: block;\n\t\tcolor: #5381c2;\n\t\ttext-decoration: none;\n\t}\n\n\t.project-detail .contact-info a\n\t{\n\t\tmargin-bottom: 5px;\n\t}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
